import { createContext, useState } from 'react';

const ChatIdContext = createContext(null);

const ChatIdProvider =({children}) => {
    const [chatId, setChatId] = useState();
    
    return (
        <ChatIdContext.Provider value={{chatId, setChatId}}>
            {children}
        </ChatIdContext.Provider>
    );
}
export {ChatIdContext, ChatIdProvider};